import { toPng } from "html-to-image";

/**
 * Capture a chart card (header title + plot) for PDF/Word/Excel export.
 * Hides interactive controls so the export matches the on-screen card layout.
 */
export async function captureChartCardImage(element) {
  if (!element) return null;

  const hidden = [];
  const scrollRestores = [];

  element.querySelectorAll(".chart-header-actions, .chart-type-dropdown-menu").forEach((el) => {
    hidden.push({ el, display: el.style.display });
    el.style.display = "none";
  });

  element.querySelectorAll(".bar-chart-scroll-container").forEach((container) => {
    scrollRestores.push({
      el: container,
      overflow: container.style.overflow,
      width: container.style.width,
      maxWidth: container.style.maxWidth,
    });
    container.style.overflow = "visible";
    container.style.width = "auto";
    container.style.maxWidth = "none";
  });

  const prevOverflow = element.style.overflow;
  element.style.overflow = "visible";
  element.classList.add("pdf-capture-mode");

  try {
    await new Promise((resolve) => {
      requestAnimationFrame(() => requestAnimationFrame(resolve));
    });

    const width = Math.max(element.scrollWidth, element.offsetWidth, 1);
    const height = Math.max(element.scrollHeight, element.offsetHeight, 1);

    return await toPng(element, {
      backgroundColor: "#ffffff",
      quality: 0.98,
      pixelRatio: 2,
      cacheBust: true,
      width,
      height,
    });
  } finally {
    hidden.forEach(({ el, display }) => {
      el.style.display = display;
    });
    scrollRestores.forEach(({ el, overflow, width, maxWidth }) => {
      el.style.overflow = overflow;
      el.style.width = width;
      el.style.maxWidth = maxWidth;
    });
    element.style.overflow = prevOverflow;
    element.classList.remove("pdf-capture-mode");
  }
}

/** Fit chart image dimensions into PDF content box while preserving aspect ratio. */
export function fitChartImageToPdf(imgWidth, imgHeight, maxWidth, maxHeight) {
  const aspectRatio = imgWidth / imgHeight;
  let width = maxWidth;
  let height = width / aspectRatio;
  if (height > maxHeight) {
    height = maxHeight;
    width = height * aspectRatio;
  }
  return { width, height };
}
